import { createStyles, Container, Title, Text, Button, SimpleGrid } from "@mantine/core";
import Icon404 from "../components/SvgAssets/Icon404";

//

const useStyles = createStyles((theme) => ({
	root: {
		padding: "120px 30px 60px",

		[theme.fn.smallerThan("sm")]: {
			padding: "120px 15px 60px",
		},
	},

	title: {
		fontWeight: 900,
		fontSize: 34,
		marginBottom: theme.spacing.md,

		[theme.fn.smallerThan("sm")]: {
			fontSize: 30,
		},
	},

	control: {
		height: 40,
		[theme.fn.smallerThan("sm")]: {
			width: "100%",
		},
	},

	mobileImage: {
		[theme.fn.largerThan("sm")]: {
			display: "none",
		},
	},

	desktopImage: {
		[theme.fn.smallerThan("sm")]: {
			display: "none",
		},
	},
}));

const Page404 = () => {
	const { classes } = useStyles();

	return (
		<Container className={classes.root}>
			<SimpleGrid spacing={80} cols={2} breakpoints={[{ maxWidth: "sm", cols: 1, spacing: 40 }]}>
				<div className={classes.mobileImage}>
					<Icon404 />
				</div>

				<div>
					<Title className={classes.title}>Something isn't right...</Title>
					<Text color="dimmed" size="lg">
						Page you are trying to open does not exist. You may have mistyped the address, or the page has been moved to
						another URL. If you think this is an error contact support.
					</Text>
					<Button variant="outline" size="md" mt="xl" className={classes.control}>
						Get back to home page
					</Button>
				</div>

				<div className={classes.desktopImage}>
					<Icon404 />
				</div>
			</SimpleGrid>
		</Container>
	);
};

export default Page404;
